"use strict";

import _classCallCheck from "/Users/dunja/Documents/code/bluedex/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/Users/dunja/Documents/code/bluedex/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "/Users/dunja/Documents/code/bluedex/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/Users/dunja/Documents/code/bluedex/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "/Users/dunja/Documents/code/bluedex/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
import { Coder } from "./abstract-coder";
// Clones the functionality of an existing Coder, but without a localName
export var AnonymousCoder = /*#__PURE__*/function (_Coder) {
  _inherits(AnonymousCoder, _Coder);
  function AnonymousCoder(coder) {
    var _this;
    _classCallCheck(this, AnonymousCoder);
    _this = _possibleConstructorReturn(this, _getPrototypeOf(AnonymousCoder).call(this, coder.name, coder.type, undefined, coder.dynamic));
    _this.coder = coder;
    return _this;
  }
  _createClass(AnonymousCoder, [{
    key: "encode",
    value: function encode(writer, value) {
      return this.coder.encode(writer, value);
    }
  }, {
    key: "decode",
    value: function decode(reader) {
      return this.coder.decode(reader);
    }
  }]);
  return AnonymousCoder;
}(Coder);